import XLSX from "xlsx";
import ProjectModel from "../../models/responses/project.model";
import {TaskSnapshot} from "../../models/responses/task.model";

export default function exportChangeToExcel(changeData: {
    newTasks: TaskSnapshot[] | any,
    deletedTasks: TaskSnapshot[] | any,
    taskDurationChanges: TaskSnapshot[] | any,
    taskNameChanges: TaskSnapshot[] | any,
    taskWBSChanges: TaskSnapshot[] | any,
    tasksDelayed: TaskSnapshot[] | any,
    tasksAhead: TaskSnapshot[] | any,
    logicChanges: any,
    tasksStarted: TaskSnapshot[] | any,
    tasksCompleted: TaskSnapshot[] | any,
    totalOldTasks: number,
    totalNewTasks: number,
}, activeProject: ProjectModel) {
    const wb = XLSX.utils.book_new();

    // I need a sheet for each type of change
    wb.SheetNames.push('New Tasks');
    wb.Sheets['New Tasks']  = XLSX.utils.json_to_sheet(changeData.newTasks.map((task: any) => ({
        ['Task ID']: task.taskCode,
        ['Task Name']: task.taskName,
        ['WBS']: task.wbsPath,
        ['Duration (hours)']: task.targetDuration / 2,
        ['Priority']: task.index,
    })));

    wb.SheetNames.push('Deleted Tasks');
    wb.Sheets['Deleted Tasks']  = XLSX.utils.json_to_sheet(changeData.deletedTasks.map((task: any) => ({
        ['Task ID']: task.taskCode,
        ['Task Name']: task.taskName,
        ['WBS']: task.wbsPath,
        ['Priority']: task.index,
    })));

    wb.SheetNames.push('Task Duration Changes');
    wb.Sheets['Task Duration Changes']  = XLSX.utils.json_to_sheet(changeData.taskDurationChanges.map((task: any) => ({
        ['Task ID']: task.taskCode,
        ['Task Name']: task.taskName,
        ['WBS']: task.wbsPath,
        ['Old Duration (hours)']: task.targetDuration / 2,
        ['New Duration (hours)']: task.newDuration / 2,
    })));

    wb.SheetNames.push('Task Name Changes');
    wb.Sheets['Task Name Changes']  = XLSX.utils.json_to_sheet(changeData.taskNameChanges.map((task: any) => ({
        ['Task ID']: task.taskCode,
        ['Old Task Name']: task.taskName,
        ['New Task Name']: task.newTaskName,
        ['WBS']: task.wbsPath,
    })));

    wb.SheetNames.push('Task WBS Changes');
    wb.Sheets['Task WBS Changes']  = XLSX.utils.json_to_sheet(changeData.taskWBSChanges.map((task: any) => ({
        ['Task ID']: task.taskCode,
        ['Task Name']: task.taskName,
        ['Old WBS']: task.wbsPath,
        ['New WBS']: task.newWBS,
    })));

    wb.SheetNames.push('Tasks Delayed');
    wb.Sheets['Tasks Delayed']  = XLSX.utils.json_to_sheet(changeData.tasksDelayed.map((task: any) => ({
        ['Task ID']: task.taskCode,
        ['Task Name']: task.taskName,
        ['WBS']: task.wbsPath,
        ['Early Finish Old']: new Date(task.earlyEndDate.seconds * 1000).toLocaleDateString(),
        ['Early Finish New']: new Date(task.earlyEndNew.seconds * 1000).toLocaleDateString(),
    })));

    wb.SheetNames.push('Tasks Ahead');
    wb.Sheets['Tasks Ahead']  = XLSX.utils.json_to_sheet(changeData.tasksAhead.map((task: any) => ({
        ['Task ID']: task.taskCode,
        ['Task Name']: task.taskName,
        ['WBS']: task.wbsPath,
        ['Early Finish Old']: new Date(task.earlyEndDate.seconds * 1000).toLocaleDateString(),
        ['Early Finish New']: new Date(task.earlyEndNew.seconds * 1000).toLocaleDateString(),
    })));

    XLSX.writeFile(wb, `${activeProject.name}_Change_Data_${new Date().getTime() / 1000}.xlsx`);
}